import { AccountRepo } from './AccountRepo'
import { AccountDomain } from '../domain/AccountDomain'

export class AccountQuery {
  constructor(private readonly repo: AccountRepo) {}

  async findByAccountNumbers(accountNumbers: string[], companyId: string): Promise<AccountDomain[]> {
    return await this.repo.findByAccountNumbers(accountNumbers, companyId);
  }

  formatAccountLabelMap(accounts: AccountDomain[]): Record<string, string> {
    return Object.fromEntries(
      accounts.map(account => [account.accountNumber, `${account.accountNumber} - ${account.description}`])
    );
  }
}
